import { render, staticRenderFns } from "./ZoomImport.vue?vue&type=template&id=65a857e1&scoped=true"
import script from "./ZoomImport.vue?vue&type=script&lang=js"
export * from "./ZoomImport.vue?vue&type=script&lang=js"
import style0 from "./ZoomImport.vue?vue&type=style&index=0&id=65a857e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a857e1",
  null
  
)

export default component.exports